if (!customElements.get('subcategory-tabs')) {
  class SubcategoryTabs extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-subcategory-track]');
      this.prevButton = this.querySelector('[data-subcategory-prev]');
      this.nextButton = this.querySelector('[data-subcategory-next]');
      if (!this.track) return;

      this.onScroll = this.updateNav.bind(this);
      this.prevButton.addEventListener('click', () => this.scrollByPage(-1));
      this.nextButton.addEventListener('click', () => this.scrollByPage(1));
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.resizeObserver = new ResizeObserver(() => this.updateNav());
      this.resizeObserver.observe(this.track);
      this.updateNav();
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.track) this.track.removeEventListener('scroll', this.onScroll);
    }

    scrollByPage(direction) {
      this.track.scrollBy({
        left: Math.round(this.track.clientWidth * 0.75) * direction,
        behavior: 'smooth'
      });
    }

    updateNav() {
      const overflow = this.track.scrollWidth > this.track.clientWidth + 2;
      this.classList.toggle('is-overflow', overflow);
      this.prevButton.hidden = !overflow;
      this.nextButton.hidden = !overflow;
      if (!overflow) return;

      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      this.prevButton.disabled = this.track.scrollLeft <= 2;
      this.nextButton.disabled = this.track.scrollLeft >= maxScroll - 2;
    }
  }

  customElements.define('subcategory-tabs', SubcategoryTabs);
}
